import React, { FC, ReactElement } from 'react'
import { Centre, AutomatedCollection } from '../../../types/contentful-v1'
import Modules from '../modules'
import { BasicPageContext } from '../../context'

interface ServiceFooterProps {
  centre: Centre
  className?: string
  // N.B. in general modules can be many things but we have an expectation
  // that for our particular queries there's just one module, an automated
  // collection of services in a spotlight
  serviceModules?: AutomatedCollection[]
}

const ServicesFooter: FC<ServiceFooterProps> = ({
  centre,
  className,
  serviceModules,
}: ServiceFooterProps): ReactElement => (
  <BasicPageContext.Consumer>
    {isBasicPage =>
      !isBasicPage && (
        <Modules
          centreTitle={centre.title}
          className={className}
          modules={serviceModules || []}
        />
      )
    }
  </BasicPageContext.Consumer>
)

export default ServicesFooter
